import { useState } from "react";
import { useNavigate } from "react-router-dom";
import QrScanner from "react-qr-barcode-scanner";
import jsQR from "jsqr";

const Scanner = () => {
  const [showCamera, setShowCamera] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [scanMessage, setScanMessage] = useState("");
  const navigate = useNavigate();

  const normalizeQrValue = (raw) => {
    const text = String(raw || "").trim();
    if (!text) return "";

    // Case 1: pure no_akaun
    if (/^\d{6,}$/.test(text)) {
      return text;
    }

    // Case 2: URL or query string containing no_akaun
    try {
      const url = new URL(text);

      const direct =
        url.searchParams.get("no_akaun") ||
        url.searchParams.get("akaun") ||
        url.searchParams.get("account");

      if (direct && /^\d{6,}$/.test(direct.trim())) {
        return direct.trim();
      }

      // try last path segment
      const parts = url.pathname.split("/").filter(Boolean);
      const last = parts[parts.length - 1];
      if (last && /^\d{6,}$/.test(last.trim())) {
        return last.trim();
      }
    } catch {
      // not a URL, continue
    }

    // Case 3: text blob containing account number
    const match = text.match(/\b\d{6,}\b/);
    if (match) return match[0];

    return text;
  };

  const goToRenterDetail = (rawValue) => {
    const qrResult = normalizeQrValue(rawValue);

    if (!qrResult) {
      setScanMessage("QR code tidak sah.");
      return;
    }

    console.log("Normalized QR Result:", qrResult);
    navigate("/renter-detail", { state: { qrResult } });
  };

  const handleImageUpload = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setScanMessage("Processing image...");

    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.width = img.width;
        canvas.height = img.height;
        context.drawImage(img, 0, 0, canvas.width, canvas.height);

        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, canvas.width, canvas.height);

        if (code?.data) {
          console.log("QR Code Result (from image):", code.data);
          goToRenterDetail(code.data);
        } else {
          console.log("No QR code found in image.");
          setScanMessage("No QR code detected in image.");
        }
      };
    };

    reader.readAsDataURL(file);
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div className="p-6 bg-white shadow-md rounded-lg w-full max-w-md">
        <h2 className="text-lg font-semibold text-gray-800 mb-4 text-center">
          QR Code Penghuni
        </h2>

        <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center">
          <label className="block cursor-pointer">
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleImageUpload}
            />
            <div className="border p-3 rounded-md hover:bg-gray-100">
              <span className="text-gray-700">Pilih Gambar</span>
            </div>
          </label>
          <p className="text-sm text-gray-500 mt-2">Atau lepaskan imej untuk diimbas</p>
        </div>

        <p
          className="mt-4 text-blue-600 text-center cursor-pointer hover:underline"
          onClick={() => {
            setShowCamera(!showCamera);
            setIsScanning(true);
            setScanMessage("");
          }}
        >
          {showCamera ? "Tutup Kamera" : "Imbas menggunakan kamera secara langsung"}
        </p>

        {showCamera && (
          <div className="mt-4 border rounded-lg overflow-hidden">
            <QrScanner
              constraints={{
                facingMode: "environment",
                width: { ideal: 1280 },
                height: { ideal: 720 },
              }}
              onUpdate={(err, result) => {
                const text = result?.text || result?.getText?.();

                if (text) {
                  setIsScanning(false);
                  setScanMessage("QR Code detected! Redirecting...");
                  goToRenterDetail(text);
                  return;
                }

                if (err) {
                  const msg = err?.message || String(err);
                  const name = err?.name || "";

                  const isNotFound =
                    name === "NotFoundException" ||
                    msg.includes("NotFoundException") ||
                    msg.includes("No MultiFormat Readers");

                  if (!isNotFound) {
                    console.error("Camera scan error:", err);
                    setScanMessage("Camera error. Check permission / HTTPS.");
                  }
                }
              }}
              style={{ width: "100%" }}
            />

            {isScanning && (
              <p className="text-center text-sm text-gray-500 mt-2 animate-pulse">
                Scanning... Hold your QR code steady
              </p>
            )}
          </div>
        )}

        {scanMessage && (
          <p className="mt-4 text-center text-gray-700">{scanMessage}</p>
        )}
      </div>
    </div>
  );
};

export default Scanner;